import Cache from '@aws-amplify/cache'
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

import { COLORS } from '@utils/colors'
import { prepareRange } from '@utils/range'
import { transformRegistryPackages } from '@utils/transformer'

const API_URL = process.env.REACT_APP_API_URL
const REGISTRY_URL = 'https://registry.npmjs.org/-/v1/'
const REGISTRY_QUERY_PARAMS =
  'quality=0.0&popularity=1.0&maintenance=1.0&size=9'
const POPULAR_PACKAGES_SEARCH = `search?text=not:unstable not:insecure&${REGISTRY_QUERY_PARAMS}`

export const packagesApi = createApi({
  reducerPath: 'packagesApi',
  baseQuery: fetchBaseQuery({ baseUrl: REGISTRY_URL }),
  endpoints: builder => ({
    fetchPopularPackages: builder.query({
      query: () => POPULAR_PACKAGES_SEARCH,
      transformResponse: transformRegistryPackages
    }),
    searchPackages: builder.query({
      query: text => `search?text=${text}&${REGISTRY_QUERY_PARAMS}`,
      transformResponse: transformRegistryPackages
    })
  })
})

export const { useFetchPopularPackagesQuery, useSearchPackagesQuery } =
  packagesApi

export const packageDataApi = createApi({
  reducerPath: 'packageDataApi',
  baseQuery: fetchBaseQuery({ baseUrl: API_URL }),
  endpoints: builder => ({
    fetchMultiplePackageData: builder.query({
      async queryFn(_arg, _queryApi, _extraOptions, fetchWithBQ) {
        let newPackages = []
        for (let i = 0; i < _arg.length; i++) {
          const { hex, rgb } = COLORS[i]
          const stringifiedArgs = JSON.stringify(_arg[i])
          const cache = Cache.getItem(stringifiedArgs)
          if (cache) {
            const jsonCache = JSON.parse(cache)
            newPackages.push({ ...jsonCache, hex, rgb })
          } else {
            const { name, version, range } = _arg[i]
            const queryParams = `name=${name}&version=${version}&range=${prepareRange(
              range
            )}`
            const { data, error } = await fetchWithBQ(
              `fetch-package-data?${queryParams}`
            )
            if (!error && data) {
              newPackages.push({ ...data, hex, rgb })
              Cache.setItem(stringifiedArgs, JSON.stringify(data))
            }
          }
        }

        return { data: newPackages }
      }
    })
  })
})

export const { useFetchMultiplePackageDataQuery } = packageDataApi
